import React from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from '../../contexts/translation';
import { Columns } from '../../pages/AssetClassParameters/Columns';
import { SisDataGrid } from '../table';
import { IDataGrid } from './AssetsDataGrid';

export const AssetClassParametersDataGrid = ({ data, handleEdit }: IDataGrid) => {
  const { translate } = useTranslation();
  const transFormName = 'AssetClassParameter.List';
  const history = useHistory();

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        html: translate!('Asset class parameters', transFormName),
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          type: 'default',
          stylingMode: 'contained',
          onClick: () => history.push(`/asset-class-parameters/new/`),
        },
      },
    );
  };

  return (
    <SisDataGrid
      onToolbarPreparing={onToolbarPreparing}
      data={data}
      keyExpr={'id'}
      transFormName={transFormName}
      columns={Columns(handleEdit, translate)}
      onCellDblClick={(e) => handleEdit && handleEdit(e)}
      allowColumnReordering={false}
      allowColumnResizing={false}
      columnChooser={false}
      pageSizeChangeVisible
    />
  );
};
